import { useCallback, useEffect, useState } from 'react'
import { CalcAkte, CalcAkteSchema } from '@dpa/common/dist'
import { trpc } from '../../App'

export function useAktePages(pageSize: number) {
  const [itemCount, setItemCount] = useState<number | undefined | null>(undefined)
  const [pageIdx, setPageIdx] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const rawData = trpc.akte.getAll.useQuery({ page: { idx: pageIdx, size: pageSize } })

  const [data, setData] = useState<Array<CalcAkte>>([])

  useEffect(() => {
    if (rawData.isLoading) return

    // If backend request failed, stop loading instead of crashing the UI
    if (rawData.error) {
      setIsLoading(false)
      return
    }

    if (!rawData.data) {
      setIsLoading(false)
      return
    }

    if (isLoading) {
      const page = rawData.data

      // If backend returns array (legacy case?), ignore for now
      if (Array.isArray(page)) {
        setIsLoading(false)
        return
      }

      const parsedData = page.data.map((p) => CalcAkteSchema.parse(p))

      setData((prev) => (prev.length === 0 ? parsedData : [...prev, ...parsedData]))
      setItemCount(page.itemCount)
      setIsLoading(false)
    }
  }, [rawData.isLoading, rawData.data, rawData.error, isLoading])

  const loadMore = useCallback(() => {
    if (!isLoading) {
      setPageIdx((prev) => prev + 1)
      setIsLoading(true)
      return true
    }
    return false
  }, [isLoading])

  return {
    data,
    isLoading,
    pageSize,
    pagesLoaded: pageIdx,
    itemCount,
    loadMore,
  }
}
